import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import AppSubSections from "../../utils/AppSubSections";
import StaticPage from "../../model/StaticPage";

interface IStaticPagesListElementProps {
  data: StaticPage;
  canEdit: boolean;
}

function StaticPagesListElement({
  data,
  canEdit,
}: IStaticPagesListElementProps) {
  // reference to the navigator
  const navigate = useNavigate();

  return (
    <div
      className="list-row"
      onClick={() => {
        navigate(
          SETTINGS.get_path({
            section: AppSections.STATIC_PAGES,
            id: data.id,
            subsection: AppSubSections.VIEW,
          }),
        );
      }}
    >
      <div className="list-row-content">
        <div className="list-row-header">
          <div className="list-row-title">
            <h3>{data.title}</h3>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StaticPagesListElement;
